import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { MessageUnreadResponse } from "./data";
import { apiGetMessageUnread } from "./service";

export const useGetMessageUnread = (options: any) => {
  return useQuery<MessageUnreadResponse>({
    queryKey: [queryKey.NEWS_LIST],
    queryFn: () =>
      apiGetMessageUnread().then((res: ApiResponse<MessageUnreadResponse>) => {
        return res.data.data;
      }),
    ...options,
  });
};
